import { Layout } from 'antd';
import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { Footer } from '@guuru/react-footer';
import { ProductImage } from '@guuru/react-named-logo';

const StyledLayout = styled(Layout)`
  && {
    height: 100vh;

    .ant-layout-content {
      min-height: auto;
    }

    &,
    footer {
      background-color: ${(props) => props.theme.backgroundColor};
    }
  }
`;

const { Content } = StyledLayout;

const LoginLayout = function () {
  return (
    <StyledLayout>
      <Content>
        <ProductImage />
        <Outlet />
      </Content>
      <Footer />
    </StyledLayout>
  );
};

export default LoginLayout;
